import {
  type Breakpoint,
  breakpoints,
} from "@repo/fika-design-system/breakpoints"
import { cdnClass, type LogoClass } from "@repo/fika-design-system/cdn-class"
import { createEffect, createMemo, createSignal, For, Show } from "solid-js"
import {
  borderClass,
  logoClass,
  pictureClass,
  wrapperRecipe,
} from "./responsive-image.css"

type Image = {
  url?: string | null
  imageClass: LogoClass
}
type AlternativeImage = Image & {
  breakpoint: Breakpoint
}
type Props = {
  image: Image
  srcset?: AlternativeImage[]
  alt: string
  class?: string
}
export function ResponsiveImage(props: Props) {
  const [mainImage, setMainImage] = createSignal<Image | null>(props.image)

  const types = createMemo(() => ({
    ...Object.fromEntries(
      props.srcset?.map(s => [s.breakpoint, s.imageClass]) || [],
    ),
    base: props.image.imageClass,
  }))

  createEffect(() => {
    setMainImage(props.image)
  })

  return (
    <Show when={mainImage()}>
      {mainImage => (
        <Show when={mainImage().url}>
          {url => (
            <div
              class={`${wrapperRecipe({ ...types() })}${props.class ? ` ${props.class}` : ""}`}
            >
              <picture class={pictureClass}>
                <For each={props.srcset || []}>
                  {img => (
                    <Show when={img.url}>
                      {url => (
                        <source
                          srcset={cdnClass(url(), img.imageClass)}
                          media={breakpoints[img.breakpoint]}
                        />
                      )}
                    </Show>
                  )}
                </For>
                <img
                  src={cdnClass(url(), mainImage().imageClass)}
                  loading="lazy"
                  alt={props.alt}
                  onError={() => {
                    setMainImage(null)
                  }}
                  class={logoClass}
                />
              </picture>
              <div class={borderClass} />
            </div>
          )}
        </Show>
      )}
    </Show>
  )
}
